/**
 * Converts the first character of the string into uppercase.
 * @param {string} val - The input value.
 * @returns {string} The value with the first character in uppercase.
 */
export const ucfirst = (val) => {
    return `${val[0].toUpperCase()}${val.substr(1)}`
}

/**
 * Converts all characters of the string into uppercase.
 * @param {string} val - The input value.
 * @returns {string} The value with all characters in uppercase.
 */
export const uppercase = (val) => {
    return val?.toUpperCase() ?? val
}

export const nl2br = (val) => {
    return val?.replace(/(\n)/g, `<br/>`)
}

export default { ucfirst, uppercase };
